import { HttpErrorResponse } from '@angular/common/http';
import { Language } from '@libraries/design-system';
import { createAction, props } from '@ngrx/store';
import {
  Address,
  CostInfo,
  EstimatedCostParams,
  OwnerEmail,
  ProjectSuccess,
  QuestionsFormPayload,
  WaitlistProperty,
} from '../models';

/* IMPLEMENTATION */
// Screen Management

export const CloseActive = createAction('[Prequal] Close Active Window');
export const ShowMain = createAction('[Prequal] Show Main Screen');
export const ShowDesktop = createAction('[Prequal] Show Desktop Screen');

// User Selections

export const SetFromUrl = createAction('[Prequal] Set from Url', props<{ payload: any }>());

export const SelectAddress = createAction(
  '[Prequal] Select Address',
  props<{ payload: Address }>()
);

export const SaveOwnerEmailList = createAction(
  '[Prequal] Save Owner Email List',
  props<{ payload: OwnerEmail[] }>()
);

// Project Creation
export const CreateProject = createAction(
  '[Prequal] Create Project',
  props<{ payload: QuestionsFormPayload }>()
);

export const CreateProjectSuccess = createAction(
  '[Prequal] Create Project Success',
  props<{ payload: ProjectSuccess }>()
);

export const CreateProjectFail = createAction(
  '[Prequal] Create Project Failure',
  props<{ payload: any }>()
);

// Project Creation Errors
export const AddressOutOfDistrict = createAction(
  '[Prequal] Address Out of District',
  props<{ payload: any }>()
);

export const MayBeEligible = createAction('[Prequal] May Be Eligible', props<{ payload: any }>());

export const MultipleAddressFound = createAction(
  '[Prequal] Multiple Address Found',
  props<{ payload: any }>()
);

// Form Stack Submission

export const SubmitIneligibleProperty = createAction(
  '[Prequal] Submit Ineligible Property',
  props<{ payload: QuestionsFormPayload }>()
);

export const SubmitIneligiblePropertySuccess = createAction(
  '[Prequal] Submit Ineligible Property Success',
  props<{ payload: any }>()
);

export const SubmitIneligiblePropertyFail = createAction(
  '[Prequal] Submit Ineligible Property Fail',
  props<{ payload: any }>()
);

export const SubmitWaitlistProperty = createAction(
  '[Prequal] Submit Waitlist Property',
  props<{ payload: WaitlistProperty }>()
);

export const SubmitWaitlistPropertySuccess = createAction(
  '[Prequal] Submit Waitlist Property Success',
  props<{ payload: any }>()
);

export const SubmitwaitlistPropertyFail = createAction(
  '[Prequal] Submit Waitlist Property Fail',
  props<{ payload: any }>()
);

// Monthly Cost Calculations
export const CalculateMonthlyCost = createAction(
  '[Prequal] Calculate Monthly Cost',
  props<{ payload: EstimatedCostParams }>()
);

export const CalculateMonthlyCostSuccess = createAction(
  '[Prequal] Calculate Monthly Cost Success',
  props<{ payload: CostInfo }>()
);

export const CalculateMonthlyCostFail = createAction(
  '[Prequal] Calculate Monthly Cost Fail',
  props<{ payload: HttpErrorResponse }>()
);

export const ReCalculateMonthlyCost = createAction(
  '[Prequal] ReCalculate Monthly Cost',
  props<{ payload: EstimatedCostParams }>()
);

export const ReCalculateMonthlyCostFail = createAction(
  '[Prequal] ReCalculate Monthly Cost Fail',
  props<{ payload: HttpErrorResponse }>()
);

export const ReCalculateMonthlyCostSuccess = createAction(
  '[Prequal] ReCalculate Monthly Cost Success',
  props<{ payload: CostInfo }>()
);

// Redirect Actions

export const RedirectToApplication = createAction('[Prequal] Redirect to Application');

export const SwitchPreferredLanguage = createAction(
  '[Prequal] Switch Preferred Language',
  props<{ preferredLanguage: Language }>()
);

export const RedirectToCongratulationsUnsecured = createAction(
  '[Prequal] Redirect to Congratulations Unsecured'
);

export const openUnsecuredUrl = createAction(
  '[Prequal] Open Unsecured Url',
  props<{ unsecuredUrl: string }>()
);
